import { createElementBlock as e, openBlock as o, createElementVNode as r } from "vue";
import l from "./index289.js";
const n = {}, a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function s(c, t, h, m, p, i) {
  return o(), e("svg", a, t[0] || (t[0] = [
    r("path", { d: "M31.5 29.482a1.25 1.25 0 0 1 .128 2.494l-.128.006h-15a1.25 1.25 0 0 1-.128-2.493l.128-.007h15Zm12-12.732a1.25 1.25 0 0 1 .128 2.494l-.128.006h-27a1.25 1.25 0 0 1-.128-2.494l.128-.006h27Zm0 12.732a1.25 1.25 0 0 1 .128 2.494l-.128.006h-6a1.25 1.25 0 0 1-.128-2.493l.128-.007h6Zm0 12.359a1.25 1.25 0 0 1 .128 2.493l-.128.007h-27a1.25 1.25 0 0 1-.128-2.494l.128-.006h27Z" }, null, -1)
  ]));
}
const f = /* @__PURE__ */ l(n, [["render", s]]);
export {
  f as default
};
